module.exports = __webpack_public_path__ + "res/flip_card.52b8dcd160b65e924a671c4d9b9f93a2.webp";